import TomSelect from 'tom-select/dist/js/tom-select.base.js'

up.compiler(
  '[data-career-search-select]',
  (element: HTMLSelectElement, { label }: { label: string }) => {
    new TomSelect(element, {
      create: false,
      controlInput: null,
      render: {
        item(data: { text: string }, escape: (s: string) => string) {
          return `<div><span class="label">${escape(label)}: </span>${escape(data.text)}</div>`
        },
      },
    })

    return () => {
      ;(
        element as HTMLSelectElement & { tomselect: InstanceType<typeof TomSelect> }
      ).tomselect.destroy()
    }
  },
)
